export default __webpack_public_path__ + "static/media/apple_inactive.3fa7f7c4.png";